import { createFileRoute } from '@tanstack/react-router';
import { PostsList } from '@client/components/admin/posts-list';

export const Route = createFileRoute('/admin/rooms/$id/updates')({ component: UpdatesTab });

/** Updates published in this room (plus the company-wide ones investors of this room also see). */
function UpdatesTab() {
  const { id: roomId } = Route.useParams();
  return <PostsList roomId={roomId} className="px-6 py-6 md:px-8" />;
}
